export default {
  Document: {
    DocumentStore: 'Kho học liệu',
    Subject: 'Môn',
    Grade: 'Khối',
    Title: 'Kho học liệu',
    Tags: 'Thẻ tìm kiếm',
    ChooseFileUpload: 'Chọn tệp tải đề lên',
    SearchTag: 'Thẻ tìm kiếm',
    UploadAnswerAndHint: 'Tải lên đáp án và lời giải',
    Answer: 'Đáp án',
    Hint: 'Lời giải',
    ChangeFill: 'Đổi sang <b>Điền từ</b>',
    ChangeChoose: 'Đổi sang <b>Chọn đáp án</b>',
    AddAnswer: 'Thêm đáp án',
    DeleteAnswer: 'Bỏ một đáp án',
    AddAnswerFill: 'Thêm ô trống',
    DeleteAnswerFill: 'Bỏ một ô trống',
    AddAnswerSelect: 'Thêm đáp án',
    DeleteAnswerSelect: 'Bỏ một đáp án',
    DeleteSentence: 'Xóa câu',
    ChangeNumberSentence: 'Thay đổi số câu',
    EnterTotalQuestion: 'Vui lòng nhập tổng số câu hỏi của bài tập',
    WarningNotEnoughSentence: 'Cảnh báo chưa nhập đủ số câu',
    WarningEnterEnoughSentenceToComplete: 'Cảnh báo chưa nhập đủ số câu bạn hãy nhập đủ số câu để hoàn thành',
    AddTheAnswer: 'Thêm câu trả lời',
    EnterAnswer: 'Nhập đáp án',
    HintAnswer: 'Chú giải đáp án',
    DetailAnswer: 'Lời giải chi tiết',
    TypeQuestion: 'Nhập câu hỏi',
    TypeContentGroupQuestion: 'Nhập câu hỏi chung',
    AddImage: 'Thêm ảnh',
    UploadAnswer: 'Tải lên lời giải',
    EnterQuantityQuestion: 'Nhập số câu hỏi',
    GiveExercise: 'Giao bài',
    EditExercise: 'Sửa',
    DeleteExercise: 'Xóa',
    ViewDetail: 'Xem',
    TryExercise: 'Làm thử',
    ShareSchool: 'Chia sẻ',
    Favorite: 'Thêm vào yêu thích',
    CancelFavorite: 'Bỏ yêu thích',
    GetStorage: 'Lấy về kho của tôi',
    GetCollect: 'Sưu tầm',
    AddFavorite: 'Thêm yêu thích',
    ChooseGrade: 'Chọn khối',
    ChooseSubject: 'Chọn môn',
    ChooseTopic: 'Chọn chủ đề',
    ChangeSchool: 'Chuyển trường',
    Question: 'Câu',
    ErrorQuestionEmpty: 'Bạn vui lòng nhập số câu hỏi',
    UploadFileSuccess: 'Tải đề lên thành công',
    UploadFileFail: 'Không thể chuyển đổi đề của bạn!',
    WarningDeleteQuestion: 'Bài soạn phải có ít nhất 1 câu hỏi',
    WarningDeleteParentQuestion: 'Câu hỏi nhóm phải có ít nhất 1 câu hỏi',
    WarningDeleteMinAnswer: 'Câu hỏi phải có ít nhất 1 đáp án',
    DublicateQuestion: 'Sao chép câu hỏi',
    DeleteQuestion: 'Xóa câu hỏi',
    QuickAction: 'Thao tác nhanh',
    ComposeExercisePlaceholder: 'Nhập câu hỏi tại đây...',
    ComposeExerciseHintPlaceholder: 'Nhập lời giải tại đây...',
    ComposeExercisePlaceholderFillQuestion: 'Nhập câu hỏi tại đây... <br> (Sau khi nhập câu hỏi và nhấn ra ngoài, phần mềm sẽ tự động nhận diện dấu cách, dấu 3 chấm, dấu gạch chân để tạo ô trống.)',
    Icon: 'Dấu',
    ChangeFile: 'Đổi file',
    Action: 'Thao tác',
    PlusClick: '+ Click',
    Sortcut: 'Phím tắt',
    QuickMoveQuestion: 'Di chuyển nhanh giữa các câu hỏi',
    AddQuestion: 'Thêm câu hỏi',
    DeleteCurrentQuestion: 'Xóa câu hỏi đang chọn',
    SaveDraft: 'Lưu nháp',
    EmptyBox: 'Ô trống {index}',
    StopShare: 'Ngừng chia sẻ',
    //
    SeeIntroduction: 'Xem hướng dẫn',
    ComposeExercise: 'Soạn bài tập',
    ExerciseImage: 'Ảnh đại diện bài',
    ComposeNew: 'Soạn bài mới',
    DescriptionComposeNew: 'Các dạng bài đa dạng, sinh động, tạo hứng thú học tập',
    ChooseFromComputer: 'Chọn từ máy tính',
    DescriptionChooseFromComputer: 'Hỗ trợ nhiều định dạng: doc, docx, pdf, png, jpg,...',
    ComposeAnswer: 'Soạn đề trắc nghiệm',
    DescriptionComposeAnswer: 'Chuyền đề bài thành dạng trắc nghiệm để HS làm bài trực tiếp trên máy',
    UploadAnswerFromComputer: 'Soạn đề tự luận',
    DescriptionUploadAnswerFromComputer: 'HS làm bài trên giấy rồi chụp lại, nộp file khi hoàn thành',
    ExtractDataToImage: 'Tự động tách bài tập thành hình ảnh',
    ExtractDataToParagraph: 'Tách câu hỏi tự động sử dụng công nghệ AI',
    ExtractDataFromAI: 'Tách câu tự động sử dụng AI',
    DescComposeExercise: 'hoặc tự tạo câu hỏi mới',
    DescExtractExercise: 'Nhấn để tải lên file bài tập hoặc kéo thả file vào đây.<br />File có định dạng xls, xlsx, doc, docx, pdf',
    UploadImageExercise: 'Nhấn để tải ảnh lên hoặc kéo thả ảnh vào đây. </br>Ảnh có định dạng JPG, JPEG, PNG',
    UploadImageAndVideoExercise: 'Nhấn để tải file lên hoặc kéo thả file vào đây. </br>File có định dạng JPG, JPEG, PNG, MP3, MP4, M4A',
    DescriptionExtractDataToImage: 'Tự động tách câu hỏi và đáp án (Áp dụng cho tệp pdf)',
    DescriptionExtractDataToParagraph: 'Chuyển đề bài từ Word sang dạng bài làm trực tuyến',
    TitleMethodExtract: 'Đâu là cách thể hiện đáp án trên đề của bạn?',
    AnswerBold: 'Tô đậm đáp án',
    AnswerUnderlined: 'Gạch chân đáp án',
    AnswerInEndSentence: 'Viết đáp án cuối câu',
    AnswerInOtherPage: 'Viết đáp án tập trung',
    ChangeExercise: 'Đổi bài tập',
    ExtractingPleaseWait: 'Đang tách câu và đáp án. Vui lòng đợi trong giây lát',
    ExtractFail: 'Tách câu hỏi không thành công',
    DescriptionExtractFail: 'Vui lòng soạn đáp án thủ công<br>hoặc chọn đề khác',
    DescriptionSuggestExtractToImage: 'Vui lòng trích rút thành hình ảnh<br>hoặc chọn đề khác',
    NotHaveTypeInAbove: 'Không có loại nào phía trên',
    PlaceholderInputTag: 'Nhập và ấn [Enter] để thêm đáp án',
    PlaceholderFillAnswer: 'Nhập đáp án rồi nhấn Enter...',
    AddFillAnswer: 'Thêm ô trống',
    ExtractSuccess: 'Đã tách thành công <b>{questions} câu hỏi, {answers} đáp án<b/>',
    ExtractNotAnswerSuccess: 'Đã tách thành công <b>{questions} câu hỏi<b/>',
    WarningChangeCancelComposeExercise: 'Hủy bỏ quá trình soạn bài?',
    AnswerAndHint: 'Đáp án & lời giải',
    MessageValidateExerciseUploadFail: 'Bạn nhập thiếu đáp án cho câu <b>{questions}</b>.<br>Hãy nhập đủ số câu để hoàn thành.',
    MessageInvalidComposeQuestionEssay: 'Bài soạn game không được chứa câu hỏi tự luận<br>',
    MessageInvalidComposeQuestionGroup: 'Bài soạn game không được chứa câu hỏi nhóm<br>',
    MessageInvalidComposeQuestionPairing: 'Bài soạn game không được chứa câu hỏi nối<br>',
    EnterAnswerHere: 'Tự nhập đáp án hoặc lời giải tại đây',
    AddQuestionUpload: 'Thêm',
    WarningNumberQuestion: 'Bạn cần nhập số câu hỏi trước khi chuyển sang bước tiếp theo.',
    InvalidQuestion: {
      ContentGroupQuestion: '(*) Thiếu nội dung câu hỏi nhóm',
      ContentQuestion: '(*) Thiếu nội dung câu hỏi',
      ContentAnswer: '(*) Thiếu nội dung đáp án câu hỏi <b>{question}</b>',
      CorrectAnswer: '(*) Chưa chọn đáp án đúng cho câu hỏi <b>{question}</b>'
    },
    /// button
    ChoseQuestionFromLibrary: 'Chọn câu từ thư viện học liệu',
    SortOrderQuestion: 'Sắp xếp thứ tự câu hỏi',
    SortQuestionInstruction: 'Kéo thả để sắp xếp thứ tự câu hỏi:',
    RemoveLink: 'Bỏ nối',
    QuickLink: 'Đảo vị trí',
    TextComposeAnswer: 'Tự soạn đáp án',

    DidNotChoseCorrectAnswerMessage: 'Bạn vui lòng chọn đáp án đúng <br>',
    DidNotMapAnswerMessage: 'Bạn chưa nối đáp án nào <br>',
    WarningRemovePairingAnswer: 'Mội cột đáp án phải có ít nhất hai lựa chọn',
    DidNotFillAnswerContentMessage: 'Bạn vui lòng nhập nội dung đáp án <br>',
    DidNotFillQuestionContentMessage: 'Bạn vui lòng nhập nội dung câu hỏi <br>',
    InvalidAnswerMappingQuestion: 'Bạn vui lòng nhập đáp án, nối đáp án ở cột trái với cột phải tương ứng.',
    InvalidAnswerSelectQuestion: 'Bạn vui lòng nhập nội dung đáp án, chọn đáp án đúng.',
    InvalidAnswerYesornoQuestion: 'Bạn vui lòng chọn đáp án đúng',
    InvalidAnswerFillQuestion: 'Bạn vui lòng nhập nội dung đáp án',
    InvalidContentParentQuestion: 'Bạn vui lòng nhập nội dung cho <b>Câu hỏi nhóm </b>',
    InvalidAnswerContentChildrenQuestionMessage: 'Bạn vui lòng nhập nội dung đáp án cho câu: <b>{questions}</b> <br>',
    InvalidAnswerCorrectChildrenQuestionMessage: 'Bạn vui lòng chọn đáp án đúng cho câu: <b>{questions}</b> <br>',
    InvalidChildrenQuestions: 'Bạn vui lòng nhập nội dung đáp án cho câu <b>{questionInvalidContents}</b>, chọn đáp án đúng cho câu <b>{questionInvalidCorrect}</b>',
    MessageConfirmRemoveQuestion: 'Bạn có chắc chắn muốn xóa câu hỏi không?',
    SwitchLabelComposeGroupQuestion: 'Đánh STT cho câu hỏi nhỏ',
    ColumnNamePlaceHolder: 'Tên cột',
    ColumnName: 'Cột {columnName}',
    AddedQuestion: 'Câu đã thêm',
    ExerciseNamePlaceholder: 'Nhập tên bài tập...',
    AddInfo: 'Bổ sung thông tin',
    ChangeComposeType: 'Đổi kiểu soạn',

    TitleUploadQuestionAttachment: 'Tải lên file bài tập hoặc kéo thả file vào đây.',
    DescUploadQuestionAttachment: 'File có định dạng doc, docx, pdf, JPG, JPEG, PNG và có dung lượng không quá 10MB',
    TypeContent: 'Nhập nội dung',

    DataFake: {
      ExampleAnswerBold: `
        <div class="pb-2">Câu 1: 36000kg = ?</div>
        <div><b>A. 36 tấn</b></div>
        <div>B. 360 tấn</div>
        <div>C. 306 tấn</div>
        <div>D. 600 tấn</div>
      `,
      ExampleAnswerUnderlined: `
        <div class="pb-2">Câu 1: 36000kg = ?</div>
        <div><u>A. 36 tấn</u></div>
        <div>B. 360 tấn</div>
        <div>C. 306 tấn</div>
        <div>D. 600 tấn</div>
      `,
      ExampleAnswerInEndSentence: `
        <div class="pb-2">Câu 1: 36000kg = ?</div>
        <div>A. 36 tấn</div>
        <div>B. 360 tấn</div>
        <div>C. 306 tấn</div>
        <div>D. 600 tấn</div>
        <div class="pt-3">Đáp án đúng: A</div>
      `,
      ExampleAnswerInOtherPage: `
        <div class="flex flex-wrap pt-5">
          <div class="w-1/2 pl-3 pb-2">Câu 1. A</div>
          <div class="w-1/2 pl-3 pb-2">Câu 5. B</div>
          <div class="w-1/2 pl-3 pb-2">Câu 2. A</div>
          <div class="w-1/2 pl-3 pb-2">Câu 6. A</div>
          <div class="w-1/2 pl-3 pb-2">Câu 3. C</div>
          <div class="w-1/2 pl-3 pb-2">Câu 7. A</div>
          <div class="w-1/2 pl-3 pb-2">Câu 4. A</div>
          <div class="w-1/2 pl-3 pb-2">Câu 8. C</div>
        </div>
      `
    },
    Tutorial: {
      QuickAction: 'Thao tác nhanh',
      Description: 'Mô tả',
      SwitchSentence: 'Chuyển câu',
      SaveDraft: 'Lưu nháp',
      ShortcutKey: 'Phím tắt',
      AnswerA: 'Đáp án A',
      AnswerB: 'Đáp án B',
      AnswerC: 'Đáp án C',
      AnswerD: 'Đáp án D',
      NextBlank: 'Chuyển sang chỗ trống tiếp theo',
      PutAnswer: 'Ngắt các đáp án trong một chỗ trống',
      AddBlank: 'Thêm chỗ trống',
      FillWord: 'Điền từ',
      Choice: 'Trắc nghiệm'
    },
    TourGuide: {
      Upload: {
        TitleProgressExerciseUpload: 'Xem quá trình soạn',
        DescriptionProgressExerciseUpload: 'Nhấn vào đây để xem tất cả câu hỏi, chọn nhanh câu cần xem.',
        TitleHelp: 'Xem phím tắt',
        DescriptionHelp: 'Nhấn vào đây để xem tất cả các phím tắt giúp thao tác khi soạn bài nhanh hơn.',
        TitleOption: 'Tùy chỉnh',
        DescriptionOption: `
          Nhấn vào đây để tùy chỉnh phiếu đáp án:<br/>
          &#8226; Chuyển dạng <b>Chọn đáp án - Điền từ</b><br/>
          &#8226; Thêm/bỏ đáp án<br/>
          &#8226; Xóa câu<br/>
        `
      },
      Compose: {
        TitleShortcut: 'Xem phím tắt',
        ContentShortcut: 'Nhấn vào đây để xem tất cả các phím tắt giúp thao tác khi soạn bài nhanh hơn.',
        TitleLibrary: 'Chọn từ thư viện',
        ContentLibrary: 'Nhấn vào đây để thêm câu hỏi có sẵn từ kho học liệu của bạn.',
        TitleCorrectAnswer: 'Chọn đáp án đúng',
        ContentCorrectAnswer: 'Nhấn vào đây để chọn đáp án đúng cho câu hỏi.'
      }
    },
    WarningChangeCancelGiveExercise: 'Hủy bỏ quá trình giao bài?',

    StudentDoExerciseLayout: 'Giao diện học sinh làm bài',
    RecommentCaption: 'Khuyến nghị',
    EnterQuestionFill: 'Nhập nội dung câu hỏi và các ký tự để phần mềm tự sinh ô trống',

    // bndung
    DownloadTemplate: 'Tải file Excel mẫu',
    UploadExerciseFile: 'Tải lên file bài tập',
    Import: 'Nhập khẩu',
    ImportExtract: 'Nhập khẩu/Tách câu tự động',
    AllRecord: 'Số bản ghi',
    ValidRecord: 'Hợp lệ',
    InValidRecord: 'Không hợp lệ',
    ResultSupportContent: 'Bạn có thể tải file dữ liệu không hợp lệ để chỉnh sửa và nhập khẩu lại. Hoặc tiếp tục nhập khẩu những bản ghi hợp lệ.',
    DownloadAllRecord: 'Tải file lỗi',
    DownloadOnlyInvalid: 'Chỉ tải những bản ghi không hợp lệ',
    AddImageGoogle: 'Thêm Hình ảnh/Video/Audio',
    AddImageOnlyGoogle: 'Thêm Hình ảnh',
    YouCanAddImage: 'Bạn có thể thêm nhanh hình ảnh tìm kiếm được từ Google',
    SearchWithGoogleSafe: 'Tìm kiếm hình ảnh bằng Google SafeSearch...',

    Error: {
      MissingExerciseInfo: 'Vui lòng nhập các thông tin tên bài tập, môn, khối.',
      MissingQuestionAttachment: 'Vui lòng tải lên file đề bài.'
    },

    LostCorrectAnswer: 'Thiếu đáp án đúng',
    MustEnoughAnswer: 'Chưa đủ đáp án',
    LostChildQuestion: 'Thiếu câu hỏi con',
    AddHint: 'Thêm lời giải',
    BackToQuestion: 'Quay lại câu hỏi',
    CanNotTryExercise: 'Vui lòng soạn câu hỏi và đáp án để làm thử!',

    ToolbarSelectAnswerTooltip: {
      Delete: 'Xóa đáp án',
      Upload: 'Tải ảnh',
      Check: 'Đánh dấu đáp án đúng'

    },

    ToolEditorTooltip: {
      Bold: 'In đậm',
      Italic: 'Nghiêng',
      Underline: 'Gạch dưới',
      Mathtype: 'Thêm công thức'
    }
  }
}
